import { Table, Tag, Button, Space, Tooltip } from "antd";
import {
  EyeOutlined,
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import FinanceService from "../../../dependencies/custom/financeService";

/**
 * Custom Fee Requests Table
 * Shows grouped custom fee requests
 * Each row = one unique fee group
 */
const CustomFeeRequestsTable = ({
  data = [],
  loading = false,
  onView,
  onEdit,
  onApprove,
  onReject,
}) => {
  const columns = [
    {
      title: "Fee Type",
      key: "feeTypeName",
      dataIndex: "feeTypeName",
      width: 100,
      render: (text) => <Tag color="blue">{text}</Tag>,
    },
    {
      title: "Description",
      key: "description",
      dataIndex: "description",
      width: 150,
      render: (text) => text || "-",
    },
    {
      title: "Amount",
      key: "amount",
      dataIndex: "amount",
      width: 110,
      align: "right",
      render: (amount) => (
        <strong>{FinanceService.formatCurrency(amount)}</strong>
      ),
    },
    {
      title: "Academic Year",
      key: "acadyr",
      dataIndex: "acadyr",
      width: 110,
      align: "center",
    },
    {
      title: "Students",
      key: "studentCount",
      width: 90,
      align: "center",
      render: (_, record) => <Tag color="cyan">{record.students.length}</Tag>,
    },
    {
      title: "Created",
      key: "createdAt",
      dataIndex: "createdAt",
      width: 130,
      render: (date) => dayjs(date).format("YYYY-MM-DD"),
    },
    {
      title: "Actions",
      key: "actions",
      width: 180,
      align: "center",
      render: (_, record) => {
        const allStudentsPending = record.students?.every(
          (s) => s.status === "Pending",
        );

        return (
          <Space size="middle">
            <Tooltip title="View Details">
              <Button
                type="link"
                size="small"
                icon={<EyeOutlined />}
                onClick={() => onView && onView(record)}
              />
            </Tooltip>

            {allStudentsPending && (
              <>
                <Tooltip title="Edit">
                  <Button
                    type="link"
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => onEdit && onEdit(record)}
                  />
                </Tooltip>

                <Tooltip title="Approve">
                  <Button
                    type="link"
                    size="small"
                    style={{ color: "#52c41a" }}
                    icon={<CheckOutlined />}
                    onClick={() => onApprove && onApprove(record.groupKey)}
                  />
                </Tooltip>

                <Tooltip title="Reject">
                  <Button
                    type="link"
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => onReject && onReject(record.groupKey)}
                  />
                </Tooltip>
              </>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={(record) => record.groupKey}
      loading={loading}
      pagination={{
        pageSize: 20,
        showSizeChanger: true,
        showTotal: (total) => `Total ${total} request group(s)`,
        responsive: true,
      }}
      scroll={{ x: 1200 }}
      size="large"
      style={{ marginTop: 16 }}
    />
  );
};

export default CustomFeeRequestsTable;
